export const hasPermissions = (permissions, permission) => {
  if (!permission) return true;

  const pArray = Array.isArray(permission) ? permission : [permission];
  let isAllowed = false;
  for (let item of pArray) {
    isAllowed = isAllowed ? isAllowed : permissions?.includes(item);
  }

  return isAllowed;
};
